import { render, staticRenderFns } from "./BackofficeProtocoloOperadora.vue?vue&type=template&id=48614427&scoped=true"
import script from "./BackofficeProtocoloOperadora.vue?vue&type=script&lang=ts"
export * from "./BackofficeProtocoloOperadora.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeProtocoloOperadora.vue?vue&type=style&index=0&id=48614427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48614427",
  null
  
)

export default component.exports